import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class ConfigService {
  private config: any;

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<any> {
    const defaultBackendUrl = "http://localhost:8081/api/v1/oqme";
    try {
      const jsonConfig: any = await this.http.get("/config.json").toPromise();
      if (!jsonConfig?.backendUrl) {
        throw new Error("config.json missing backendUrl");
      }
      const config = await this.http
        .get(`${jsonConfig["backendUrl"]}/admin/config`)
        .toPromise();
      this.config = config;
      return config;
    } catch (error) {
      console.warn(
        "config.json missing or failed; trying default backend URL:",
        error
      );

      try {
        const config = await this.http
          .get(`${defaultBackendUrl}/admin/config`)
          .toPromise();
        this.config = config;
        return config;
      } catch (innerError) {
        console.error(
          "Failed to load config from default backend URL:",
          innerError
        );
        throw innerError;
      }
    }
  }

  get(key: string) {
    return this.config ? this.config[key] : null;
  }

  set(key: string, value: unknown): void {
    if (!this.config) {
      this.config = {};
    }
    this.config[key] = value;
  }

  areNotificationsDisabled(): boolean {
    return this.get("notificationsDisabled") === true;
  }

  isConfigLoaded(): boolean {
    return this.config !== undefined && this.config !== null;
  }
}
